import React, { useCallback, useEffect, useState } from 'react';
import GetBackToPeopleSection from './GetBackToPeopleSection';
import './owed-replies-page.scss';

interface OwedRepliesPageProps {
  /** Hide the in-page heading (the app-view layout renders its own header). */
  hideHeading?: boolean;
  /** Report a subtitle string ("N to get back to") to the host header. */
  onSubtitleChange?: (subtitle: string) => void;
  /** Report the open-item count for the host's title badge. */
  onTitleCountChange?: (count: number) => void;
  /** Hand the sweep controls to the host header. */
  onActionsChange?: (actions: React.ReactNode | null) => void;
}

/**
 * "Owed replies" app: the standalone home of the Get back to people list —
 * people across Email / WhatsApp / Slack / Granola who are genuinely waiting
 * on a reply from the user. Kept separate from Reminders so the Todoist-backed
 * todo list and the swept followup list don't mix.
 */
const OwedRepliesPage: React.FC<OwedRepliesPageProps> = ({
  hideHeading,
  onSubtitleChange,
  onTitleCountChange,
  onActionsChange,
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!onSubtitleChange) return;
    onSubtitleChange(
      count === 0
        ? 'All caught up'
        : `${count} ${count === 1 ? 'person' : 'people'} waiting on you`,
    );
  }, [count, onSubtitleChange]);

  useEffect(() => {
    onTitleCountChange?.(count);
  }, [count, onTitleCountChange]);

  const handleCountChange = useCallback((n: number) => setCount(n), []);

  return (
    <div className='owed-replies-page'>
      <div className='owed-replies-section'>
        {!hideHeading && (
          <div className='owed-replies-header'>
            <h1 className='owed-replies-heading'>Owed replies</h1>
          </div>
        )}
        <GetBackToPeopleSection
          onCountChange={handleCountChange}
          onActionsChange={onActionsChange}
        />
      </div>
    </div>
  );
};

export default OwedRepliesPage;
